import { Component, OnInit, QueryList, AfterViewInit, ContentChildren, AfterViewChecked, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerticalTabComponent } from '../vertical-tab/vertical-tab.component';
import { TabsModule } from 'ngx-bootstrap';

@Component({
  selector: 'app-vertical-tab-group',
  templateUrl: './vertical-tab-group.component.html',
  styleUrls: ['./vertical-tab-group.component.css']
})
export class VerticalTabGroupComponent implements OnInit, AfterViewInit {
  // https://blog.thoughtram.io/angular/2015/04/09/developing-a-tabs-component-in-angular-2.html

  @Input()
  public useTabColors = true;
  @Input()
  public stacked = true;

  @ContentChildren(VerticalTabComponent)
  public tabContentChildren: QueryList<VerticalTabComponent>;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    if (!this.hasSelectedTab()) {
      this.selectFirstTab();
    }

    this.tabContentChildren
      .changes
      .subscribe((s: QueryList<VerticalTabComponent>) => {
        if (!this.hasSelectedTab()) {
          this.selectFirstTab();
        }
      });
  }

  public selectTab(tab: VerticalTabComponent) {
    this.tabContentChildren.forEach(t => t.isActive = false);
    tab.isActive = true;
  }

  private hasSelectedTab(): boolean {
    return this.tabContentChildren.filter(c => c.isActive).length === 1;
  }

  private selectFirstTab(): void {
    if (this.tabContentChildren.length) {
      setTimeout(() => this.selectTab(this.tabContentChildren.first), 0);
    }
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/components/vertical-tab-group/vertical-tab-group.component.ts